import { FullHeader } from './FullHeader';
import { SlimHeader } from './SlimHeader';
import { FullFooter } from './FullFooter';
import { SlimFooter } from './SlimFooter';

export const componentMap = {
  'full-header': FullHeader,
  'slim-header': SlimHeader,
  'full-footer': FullFooter,
  'slim-footer': SlimFooter,
};

export type ComponentKey = keyof typeof componentMap;

export const getComponentKey = (component?: string | null): ComponentKey => {
  const defaultKey: ComponentKey = 'slim-footer';

  if (!component) {
    return defaultKey;
  }

  if (!(component in componentMap)) {
    console.warn(
      `Component "${component}" not found, defaulting to SlimFooter`
    );
    return defaultKey;
  }

  return component as ComponentKey;
}

export const getComponent = (component?: ComponentKey | null) => {
  const defaultComponent = SlimFooter;

  if (!component) {
    return defaultComponent;
  }

  if (!(component in componentMap)) {
    console.warn(
      `Component "${component}" not found, defaulting to SlimFooter`
    );
    return defaultComponent;
  }

  return componentMap[component];
};
